import { z } from "zod";

import { ListParams } from "~/shared/zod";

const zDirectionAsNumber = z.number().int().min(0).max(ListParams.Sort.zDirection.options.length);

const NUMBER_BY_DIRECTION = Object.fromEntries(
  [ListParams.Sort.Direction.ASC, ListParams.Sort.Direction.DESC].map((value, index) => [
    value,
    index,
  ]),
) as Record<ListParams.Sort.Direction, number>;

function zSchema<FieldNames extends z.ZodEnum<[string, ...string[]]>>(fieldNames: FieldNames) {
  return z.array(
    z.object({
      selector: fieldNames,
      orderType: zDirectionAsNumber,
    }),
  );
}
type Schema<FieldNames extends z.ZodEnum<[string, ...string[]]>> = z.infer<
  ReturnType<typeof zSchema<FieldNames>>
>;

export { NUMBER_BY_DIRECTION, zDirectionAsNumber, zSchema };
export type { Schema };
